import gql from "graphql-tag";

export const createBatch = gql`
  mutation CreateBatch($data: BatchCreateInput!) {
    createBatch(data: $data) {
      id
    }
  }
`;
